import { Box, Stepper, Step, StepLabel } from "@mui/material";
import { makeStyles } from "@mui/styles";
interface Props {
  steps: Array<number> | undefined;
  activeStep: number;
}

const color = localStorage.getItem("primaryColor");

const stepStyles = makeStyles({
  stepper: {
    "& svg": {
      width: "3.5rem",
      height: "3.5rem",
    },
    "& .css-1u4zpwo-MuiSvgIcon-root-MuiStepIcon-root.Mui-completed": {
      color: color,
    },
    "& .css-1u4zpwo-MuiSvgIcon-root-MuiStepIcon-root.Mui-active": {
      color: color,
    },
    "& .css-4ff9q7.Mui-active": { color: color },
  },
  container: {
    display: "flex",
    width: "35%",
    minWidth: "32rem",
    margin: "0 auto 2rem auto",
  },
});

export const FormSteps = ({ steps, activeStep }: Props) => {
  const classes = stepStyles();

  return (
    <Box sx={{ width: "100%" }}>
      <Stepper
        activeStep={activeStep}
        alternativeLabel
        className={classes.container}
      >
        {steps?.map((step, index) => (
          <Step key={index} className={classes.stepper}>
            <StepLabel>{""}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};
